/* Numsy webchat-widget (31 aug 2026). Zelfstandig vanilla JS, geen dependencies.
   Praat met de Cloudflare-worker (data-api op de loader-div): /api/webchat,
   /api/webchat/order en /api/webchat/escalate. Gesprek leeft in sessionStorage
   (alleen deze browser-tab-sessie, geen cookies). Alle classes hebben de
   nchat-prefix om botsingen met het thema te voorkomen. */
(function () {
  'use strict';
  var host = document.querySelector('[data-numsy-chat]');
  if (!host || window.__numsyChat) return;
  window.__numsyChat = true;
  var API = (host.getAttribute('data-api') || 'https://app.numsy.com').replace(/\/$/, '');
  var OPSLAG = 'numsyChatGesprek';
  var MAX_BEURTEN = 12;

  var css = '' +
    '.nchat-fab{position:fixed;right:16px;bottom:16px;z-index:9990;width:56px;height:56px;border-radius:50%;background:#262B49;color:#fff;border:none;cursor:pointer;box-shadow:0 4px 16px rgba(38,43,73,.35);display:flex;align-items:center;justify-content:center;transition:transform .15s ease}' +
    '.nchat-fab:hover{transform:scale(1.06)}' +
    '.nchat-fab svg{width:26px;height:26px;fill:none;stroke:#fff;stroke-width:2}' +
    '.nchat-venster{position:fixed;right:16px;bottom:16px;z-index:9991;width:min(380px,calc(100vw - 32px));max-height:min(620px,calc(100vh - 32px));background:#fff;border-radius:16px;box-shadow:0 8px 40px rgba(38,43,73,.28);display:flex;flex-direction:column;overflow:hidden;font-family:inherit}' +
    '@media (max-width:480px){.nchat-venster{right:8px;left:8px;bottom:8px;width:auto}}' +
    '.nchat-kop{background:#262B49;color:#fff;padding:14px 16px;display:flex;align-items:center;gap:10px}' +
    '.nchat-kop-titel{flex:1;min-width:0}.nchat-kop-titel strong{display:block;font-size:15px}.nchat-kop-titel span{font-size:12px;opacity:.8}' +
    '.nchat-sluit{background:none;border:none;color:#fff;font-size:22px;line-height:1;cursor:pointer;padding:4px 8px}' +
    '.nchat-berichten{flex:1;overflow-y:auto;padding:14px;display:flex;flex-direction:column;gap:10px;background:#F7F7FA}' +
    '.nchat-b{max-width:85%;padding:10px 13px;border-radius:14px;font-size:14px;line-height:1.45;white-space:pre-wrap;word-wrap:break-word}' +
    '.nchat-b-bot{background:#fff;color:#262B49;border:1px solid #E6E7EE;border-bottom-left-radius:4px;align-self:flex-start}' +
    '.nchat-b-mij{background:#262B49;color:#fff;border-bottom-right-radius:4px;align-self:flex-end}' +
    '.nchat-bronnen{align-self:flex-start;font-size:12px;display:flex;flex-direction:column;gap:2px;margin-top:-4px}' +
    '.nchat-bronnen a{color:#262B49;text-decoration:underline}' +
    '.nchat-chips{display:flex;flex-wrap:wrap;gap:6px;padding:0 14px 8px;background:#F7F7FA}' +
    '.nchat-chip{background:#fff;border:1px solid #C9CBDA;border-radius:999px;padding:6px 12px;font-size:13px;color:#262B49;cursor:pointer}' +
    '.nchat-chip:hover{border-color:#262B49}' +
    '.nchat-voet{display:flex;gap:8px;padding:10px 12px;border-top:1px solid #E6E7EE;background:#fff}' +
    '.nchat-voet textarea{flex:1;resize:none;border:1px solid #C9CBDA;border-radius:10px;padding:9px 12px;font-size:16px;font-family:inherit;line-height:1.35;max-height:90px;color:#262B49;background:#fff}' +
    '.nchat-voet textarea:focus{outline:2px solid #262B49}' +
    '.nchat-stuur{background:#262B49;color:#fff;border:none;border-radius:10px;padding:0 16px;font-size:14px;font-weight:600;cursor:pointer}' +
    '.nchat-stuur:disabled{opacity:.5;cursor:default}' +
    '.nchat-form{align-self:stretch;background:#fff;border:1px solid #E6E7EE;border-radius:14px;padding:12px;display:flex;flex-direction:column;gap:8px}' +
    '.nchat-form label{font-size:12px;color:#666A7C}' +
    '.nchat-form input,.nchat-form textarea{border:1px solid #C9CBDA;border-radius:8px;padding:8px 10px;font-size:16px;font-family:inherit;width:100%;box-sizing:border-box;color:#262B49;background:#fff}' +
    '.nchat-form-knoppen{display:flex;gap:8px;margin-top:2px}' +
    '.nchat-knop{background:#262B49;color:#fff;border:none;border-radius:8px;padding:8px 14px;font-size:13px;font-weight:600;cursor:pointer}' +
    '.nchat-knop-licht{background:#fff;color:#262B49;border:1px solid #C9CBDA}' +
    '.nchat-typt{align-self:flex-start;font-size:13px;color:#666A7C;padding:4px 2px}' +
    '.nchat-duim{align-self:flex-start;display:flex;gap:4px;margin-top:-6px}' +
    '.nchat-duim button{background:none;border:none;cursor:pointer;font-size:14px;padding:2px 4px;opacity:.45}' +
    '.nchat-duim button:hover{opacity:1}' +
    '.nchat-duim .nchat-duim-dank{font-size:12px;color:#666A7C;align-self:center}' +
    '.nchat-onder{font-size:11px;color:#8A8DA0;text-align:center;padding:4px 10px 8px;background:#fff}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var open = false, bezig = false;
  var gesprek = [];
  try { gesprek = JSON.parse(sessionStorage.getItem(OPSLAG) || '[]') || []; } catch (e) { gesprek = []; }

  function bewaar() {
    try { sessionStorage.setItem(OPSLAG, JSON.stringify(gesprek.slice(-MAX_BEURTEN * 2))); } catch (e) {}
  }

  /* ── opbouw ── */
  var fab = document.createElement('button');
  fab.className = 'nchat-fab';
  fab.type = 'button';
  fab.setAttribute('aria-label', 'Chat met Numsy openen');
  fab.innerHTML = '<svg viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  document.body.appendChild(fab);

  var venster = document.createElement('div');
  venster.className = 'nchat-venster';
  venster.style.display = 'none';
  venster.setAttribute('role', 'dialog');
  venster.setAttribute('aria-label', 'Numsy chat');
  venster.innerHTML =
    '<div class="nchat-kop"><div class="nchat-kop-titel"><strong>Numsy</strong><span>We denken met je mee</span></div>' +
    '<button type="button" class="nchat-sluit" aria-label="Chat sluiten">&times;</button></div>' +
    '<div class="nchat-berichten"></div>' +
    '<div class="nchat-chips"></div>' +
    '<div class="nchat-voet"><textarea rows="1" placeholder="Typ je vraag..." aria-label="Je vraag"></textarea>' +
    '<button type="button" class="nchat-stuur">Stuur</button></div>' +
    '<div class="nchat-onder">Antwoorden komen van onze slimme assistent. Kom je er niet uit? Dan sturen we je vraag door naar ons team.</div>';
  document.body.appendChild(venster);

  var lijst = venster.querySelector('.nchat-berichten');
  var chips = venster.querySelector('.nchat-chips');
  var invoer = venster.querySelector('textarea');
  var stuurKnop = venster.querySelector('.nchat-stuur');

  function toonChips() {
    chips.innerHTML = '';
    [['Waar is mijn bestelling?', ordervormTonen],
     ['Retourneren', function () { verstuur('Hoe kan ik iets retourneren?'); }],
     ['Over de app', function () { verstuur('Wat kan de Numsy-app en hoe krijg ik toegang?'); }],
     ['Doorsturen naar support', escalatievormTonen]
    ].forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'nchat-chip'; b.textContent = c[0];
      b.addEventListener('click', c[1]);
      chips.appendChild(b);
    });
  }

  function bubbel(rol, tekst) {
    var d = document.createElement('div');
    d.className = 'nchat-b ' + (rol === 'user' ? 'nchat-b-mij' : 'nchat-b-bot');
    d.textContent = tekst;
    lijst.appendChild(d);
    lijst.scrollTop = lijst.scrollHeight;
    return d;
  }
  function bronnenTonen(bronnen) {
    if (!bronnen || !bronnen.length) return;
    var d = document.createElement('div');
    d.className = 'nchat-bronnen';
    bronnen.forEach(function (br) {
      if (!br.url) return;
      var a = document.createElement('a');
      a.href = br.url; a.target = '_blank'; a.rel = 'noopener';
      a.textContent = 'Lees meer: ' + (br.title || br.url);
      d.appendChild(a);
    });
    if (d.children.length) { lijst.appendChild(d); lijst.scrollTop = lijst.scrollHeight; }
  }

  // Duimpjes onder een botantwoord; tid komt uit de server-response en hoort bij dit antwoord.
  function duimpjesTonen(tid) {
    if (!tid) return;
    var d = document.createElement('div');
    d.className = 'nchat-duim';
    [['👍', true], ['👎', false]].forEach(function (k) {
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = k[0];
      b.setAttribute('aria-label', k[1] ? 'Dit antwoord hielp' : 'Dit antwoord hielp niet');
      b.addEventListener('click', function () {
        fetch(API + '/api/webchat/feedback', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ tid: tid, helpful: k[1] })
        }).catch(function () {});
        d.innerHTML = '<span class="nchat-duim-dank">' + (k[1] ? 'Fijn om te horen!' : 'Dank je, hier leren we van.') + '</span>';
      });
      d.appendChild(b);
    });
    lijst.appendChild(d);
  }

  function welkom() {
    if (lijst.children.length) return;
    if (gesprek.length) {
      gesprek.forEach(function (m) { bubbel(m.role, m.content); });
    } else {
      bubbel('assistant', 'Hoi! Ik ben de assistent van Numsy. Stel me gerust een vraag over onze producten, je bestelling, levering, retourneren of de Numsy-app.');
    }
  }

  /* ── chatten ── */
  function verstuur(tekst) {
    tekst = String(tekst || invoer.value || '').trim();
    if (!tekst || bezig) return;
    invoer.value = '';
    bezig = true; stuurKnop.disabled = true;
    bubbel('user', tekst);
    gesprek.push({ role: 'user', content: tekst });
    bewaar();
    var typt = document.createElement('div');
    typt.className = 'nchat-typt'; typt.textContent = 'Numsy denkt na...';
    lijst.appendChild(typt); lijst.scrollTop = lijst.scrollHeight;
    fetch(API + '/api/webchat', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: gesprek.slice(-MAX_BEURTEN) })
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        typt.remove();
        if (res.ok && res.d && res.d.antwoord) {
          bubbel('assistant', res.d.antwoord);
          gesprek.push({ role: 'assistant', content: res.d.antwoord });
          bewaar();
          bronnenTonen(res.d.bronnen);
          duimpjesTonen(res.d.tid);
        } else {
          bubbel('assistant', (res.d && res.d.error) || 'Antwoorden lukte even niet. Probeer het zo opnieuw, of stuur je vraag door naar ons team.');
        }
      })
      .catch(function () {
        typt.remove();
        bubbel('assistant', 'De verbinding lukte even niet. Probeer het zo opnieuw, of mail ons op support@numsy.nl.');
      })
      .finally(function () { bezig = false; stuurKnop.disabled = false; invoer.focus(); });
  }

  /* ── bestelstatus ── */
  function ordervormTonen() {
    if (venster.querySelector('.nchat-form')) return;
    var f = document.createElement('form');
    f.className = 'nchat-form';
    f.innerHTML =
      '<label>Bestelnummer (staat in je bestelbevestiging, bijv. NUMSY_10622)</label>' +
      '<input name="order" required placeholder="NUMSY_10622">' +
      '<label>E-mailadres van de bestelling</label>' +
      '<input name="email" type="email" required placeholder="jij@voorbeeld.nl">' +
      '<div class="nchat-form-knoppen"><button type="submit" class="nchat-knop">Zoek op</button>' +
      '<button type="button" class="nchat-knop nchat-knop-licht">Annuleer</button></div>';
    lijst.appendChild(f); lijst.scrollTop = lijst.scrollHeight;
    f.querySelector('.nchat-knop-licht').addEventListener('click', function () { f.remove(); });
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var knop = f.querySelector('[type=submit]');
      knop.disabled = true; knop.textContent = 'Zoeken...';
      fetch(API + '/api/webchat/order', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order: f.order.value, email: f.email.value })
      }).then(function (r) { return r.json(); })
        .then(function (d) {
          f.remove();
          if (d && d.gevonden) {
            var regels = ['Bestelling ' + d.bestelling + ' is ' + d.status + '.'];
            if (d.besteldOp) regels.push('Besteld op ' + d.besteldOp + '.');
            if (d.verzondenOp) regels.push('Verzonden op ' + d.verzondenOp + '.');
            bubbel('assistant', regels.join(' '));
            if (d.tracking && d.tracking.length) {
              bronnenTonen(d.tracking.map(function (t) {
                return { url: t.url, title: 'Volg je pakket' + (t.vervoerder ? ' via ' + t.vervoerder : '') + (t.nummer ? ' (' + t.nummer + ')' : '') };
              }));
            }
          } else {
            bubbel('assistant', (d && (d.melding || d.error)) || 'Opzoeken lukte even niet. Probeer het zo opnieuw.');
          }
        })
        .catch(function () { f.remove(); bubbel('assistant', 'Opzoeken lukte even niet. Probeer het zo opnieuw of mail support@numsy.nl.'); });
    });
  }

  /* ── escalatie naar support ── */
  function escalatievormTonen() {
    if (venster.querySelector('.nchat-form')) return;
    var laatste = '';
    for (var i = gesprek.length - 1; i >= 0; i--) if (gesprek[i].role === 'user') { laatste = gesprek[i].content; break; }
    var f = document.createElement('form');
    f.className = 'nchat-form';
    f.innerHTML =
      '<label>Je naam (mag leeg)</label><input name="naam" placeholder="Voornaam">' +
      '<label>Je e-mailadres</label><input name="email" type="email" required placeholder="jij@voorbeeld.nl">' +
      '<label>Je vraag voor ons team</label><textarea name="vraag" rows="3" required></textarea>' +
      '<div class="nchat-form-knoppen"><button type="submit" class="nchat-knop">Verstuur</button>' +
      '<button type="button" class="nchat-knop nchat-knop-licht">Annuleer</button></div>';
    f.vraag.value = laatste;
    lijst.appendChild(f); lijst.scrollTop = lijst.scrollHeight;
    f.querySelector('.nchat-knop-licht').addEventListener('click', function () { f.remove(); });
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var knop = f.querySelector('[type=submit]');
      knop.disabled = true; knop.textContent = 'Versturen...';
      fetch(API + '/api/webchat/escalate', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ naam: f.naam.value, email: f.email.value, vraag: f.vraag.value, transcript: gesprek.slice(-MAX_BEURTEN) })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          f.remove();
          bubbel('assistant', res.ok && res.d && res.d.ok
            ? (res.d.melding || 'Je vraag is doorgestuurd naar ons supportteam. Je hoort snel van ons.')
            : ((res.d && res.d.error) || 'Versturen lukte nu niet. Mail je vraag direct naar support@numsy.nl.'));
        })
        .catch(function () { f.remove(); bubbel('assistant', 'Versturen lukte nu niet. Mail je vraag direct naar support@numsy.nl.'); });
    });
  }

  /* ── open/dicht ── */
  function zetOpen(aan) {
    open = aan;
    venster.style.display = aan ? 'flex' : 'none';
    fab.style.display = aan ? 'none' : 'flex';
    if (aan) { welkom(); toonChips(); invoer.focus(); }
  }
  fab.addEventListener('click', function () { zetOpen(true); });
  venster.querySelector('.nchat-sluit').addEventListener('click', function () { zetOpen(false); });
  stuurKnop.addEventListener('click', function () { verstuur(); });
  invoer.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && !ev.shiftKey) { ev.preventDefault(); verstuur(); }
  });
})();
